import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearBumperProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearBumper(props: RearBumperProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Bumper"
      width={235}
      height={502}
      viewBox="0 0 235 502"
      position={{top: 0, right: 0}}
    >
      <path
        d="M211 378C204.997 394.162 193.202 404.238 186 410C183.861 411.711 181.112 413.568 178 415C174.259 421.941 171.101 427.031 169 431C162.633 443.027 154.013 454.411 127 460C119.083 461.638 101.95 470.5 87 477C64 487 23 500 1 501L3 501C62.0276 499.689 146.144 488.158 189 462C230.123 436.9 234 357.237 234 298V251V204C234 144.763 230.123 65.1003 189 40C146.144 13.8419 62.0276 2.31077 3 1H1C23 2 64 15 87 25C101.95 31.5 119.083 40.3619 127 42C154.013 47.5888 162.633 58.9731 169 71C171.101 74.9686 174.259 80.0591 178 87C181.112 88.4319 183.861 90.2891 186 92C193.202 97.7621 204.997 107.838 211 124C224 159.001 224 216.945 224 250.951V251V251.049C224 285.055 224 342.999 211 378Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M211 378C204.997 394.162 193.202 404.238 186 410C183.861 411.711 181.112 413.568 178 415C174.259 421.941 171.101 427.031 169 431C162.633 443.027 154.013 454.411 127 460C119.083 461.638 101.95 470.5 87 477C64 487 23 500 1 501L3 501C62.0276 499.689 146.144 488.158 189 462C230.123 436.9 234 357.237 234 298V251V204C234 144.763 230.123 65.1003 189 40C146.144 13.8419 62.0276 2.31077 3 1H1C23 2 64 15 87 25C101.95 31.5 119.083 40.3619 127 42C154.013 47.5888 162.633 58.9731 169 71C171.101 74.9686 174.259 80.0591 178 87C181.112 88.4319 183.861 90.2891 186 92C193.202 97.7621 204.997 107.838 211 124C224 159.001 224 216.945 224 250.951V251V251.049C224 285.055 224 342.999 211 378Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
